import { BoxProps, ColorOptions, TextNewProps, TextProps } from '@jfs/ui-new'
import { colors } from '../../util/colors'
import { isMobileWidth, isTabletWidth } from '../../util/util'

// const PaleBlue = '#0070B60F'

const shadow = (isScreenType: boolean) =>
  ({
    shadowColor: isScreenType ? 'GREY_MATTE' : ('LIGHT_BLACK' as ColorOptions),
    shadowOffset: {
      width: isScreenType ? 0 : 0,
      height: isScreenType ? 0 : 0,
    },
    shadowOpacity: isScreenType ? 0 : 0.5,
    shadowRadius: isScreenType ? 0 : 12,
    elevation: 2,
  } as BoxProps)

export const styles = (isScreenType: boolean, breakpoint: number, resPadding: number) => {
  const isTab = isTabletWidth(breakpoint)
  const isMob = isMobileWidth(breakpoint)
  return {
    mainView: () =>
      ({
        alignSelf: 'center',
        w: isScreenType ? '100%' : isTab ? '100%' : '100%',
      } as BoxProps),
    productMetaDataWrap: (top: number) =>
      ({
        // paddingTop: isMob ? 0 : 30,
        mt: isMob ? top + 5 : 2 * top + 5,
        bg: 'WHITE',
        width: isScreenType ? (isMob ? '100%' : breakpoint - resPadding * 2 - (isTab ? 0 : 30)) : undefined,
        ...shadow(isScreenType),
        // ml: isScreenType ? (isTab || isMob ? 0 : 85) : undefined,
        borderRadius: 12,
      } as BoxProps),
    flatlistWrapper: {
      pl: isScreenType ? (isTab || isMob ? 0 : 40) : 20,
      pr: isScreenType ? (isTab || isMob ? 0 : 40) : 20,
      w: '100%',
    } as BoxProps,
    tooltipStyle: () =>
      ({
        pt: 10,
      } as BoxProps),
    footerView: {
      flexDirection: isMob ? 'column' : 'row',
      backgroundColor: colors.HOVER_SOLID as ColorOptions,
      width: '100%',
      justifyContent: 'space-between',
      pv: isScreenType ? 10 : isTab ? 15 : isMob ? 0 : 10,
      h: isMob ? undefined : 120,
      mt: isMob ? 55 : isTab ? 0 : 0,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
    } as BoxProps,
    googlePlayView: {
      flexDirection: isMob ? 'row-reverse' : 'row',
      justifyContent: isMob ? 'flex-end' : 'center',
      alignSelf: isMob ? undefined : 'center',
      pr: isMob ? 0 : isScreenType ? 80 : 80,
      pl: isMob ? 24 : 0,
      pv: isMob ? 24 : 0,
    } as BoxProps,
    headerTitle: {
      fontSize: isScreenType ? 14 : 18,
      color: 'BLACK_21',
      fontFamily: 'jiotype-bold',
    } as TextProps,
    boldHeader: {
      fontSize: isScreenType ? (isTab ? 16 : isMob ? 18 : 24) : 16,
      color: colors.HIGHLIGHT,
      fontFamily: 'jiotype-medium',
      fontWeight: 'bold',
    } as TextNewProps,
    footerDescription: {
      fontSize: isScreenType ? (isTab ? 12 : isMob ? 14 : 18) : 12,
      color: 'PRIMARY_GREY',
      fontFamily: 'jiotype-medium',
    } as TextNewProps,
    renderItem: {
      pt: 32,
      ph: 24,
    } as BoxProps,
    contentContainer: (hovering: boolean, _index: number) => {
      return {
        pt: isScreenType ? (isTab ? 0 : 32) : 16,
        pb: isMob ? 0 : isScreenType ? 32 : 16,
        // minWidth: isScreenType ? (isMob || isTab ? undefined : 440) : isTab ? undefined : 360,
        // maxWidth: isScreenType ? (isMob ? undefined : '100%') : 390,
        bg: hovering ? (colors.ITEM_HOVER as ColorOptions) : 'WHITE',
        flexDirection: 'row',
        pl: isScreenType ? (isMob ? 24 : 40) : 25,
        pr: isScreenType ? (isMob ? 24 : isTab ? 8 : 40) : 25,
        // mr: isMob ? 0 : isScreenType ? (isLeftSideItem ? breakpoint / 16 : 0) : 0,
        // ml: isMob ? 0 : isScreenType ? (isLeftSideItem ? 0 : breakpoint / 16) : 0,
        borderRadius: 12,
      } as BoxProps
    },
    descWrapper: {
      maxWidth: isScreenType ? (isMob || isTab ? undefined : '85%') : isTab ? undefined : 300,
      width: isMob ? '90%' : undefined,
      pt: isScreenType ? 5 : undefined,
    } as BoxProps,
    contentWrapper: {
      maxWidth: isMob ? undefined : isTab ? '85%' : isScreenType ? '90%' : 25,
      flexWrap: 'wrap',
      // width: isMob ? '100%' : isTab ? '100%' : '80%',
      pl: isMob ? 16 : 32,
    } as BoxProps,
    renderedContentMainGroup: {
      pt: isScreenType ? (isMob ? 0 : isTab ? 40 : 52) : 10,
      borderRadius: 12,
      pb: isScreenType ? (isMob ? 0 : isTab ? 8 : 30) : 10,
    } as BoxProps,
    categoryTextHeader: {
      fontSize: isScreenType ? (isMob || isTab ? 18 : 24) : 14,
      color: colors.HIGHLIGHT,
      fontFamily: 'jiotype-bold',
    } as TextNewProps,
    categoryTextDesc: {
      fontSize: isScreenType ? (isMob || isTab ? 14 : 18) : 12,
      fontFamily: 'jiotype-medium',
      lineHeight: isScreenType ? (isMob || isTab ? 21 : 27) : 18,
      color: 'PRIMARY_GREY',
    } as TextNewProps,
    modal: (resPadding: number, top: number, width: number) =>
      ({
        alignSelf: isTab && !isScreenType ? 'center' : 'flex-end',
        underlayColor: 'TRANSPARENT',
        right: isMob ? 0 : resPadding,
        top: isMob ? top + 20 : 0,
        w: isMob ? '100%' : isScreenType ? undefined : isTab ? '85%' : width - 2 * resPadding,
      } as BoxProps),
    leftImgContainer: {
      flexDirection: isScreenType && isMob ? 'column' : 'row',
      // w: isMob ? '100%' : '60%',
      // bg: 'RED',
      pr: isMob ? 24 : 20,
      pl: isMob ? 24 : isScreenType ? 10 : 0,
      // justify: 'center',
    } as BoxProps,
    jioBizImageContainer: {
      top: -26,
      w: isTab ? 150 : 160,
      pl: isScreenType ? (isMob ? 10 : isTab ? 30 : 10) : 80,
      // left: isScreenType ? (isTab ? -40 : isMob ? -30 : -80) : -40,
    } as BoxProps,
    businessAppContainer: {
      pl: isScreenType ? (isTab ? 0 : isMob ? 0 : 30) : 72,
      justify: 'center',
    } as BoxProps,
    underlayedTrans: {
      underlayColor: 'TRANSPARENT',
      alignSelf: 'flex-start',
      // borderRadius: 8,
      height: 32,
      overflow: 'hidden',
    } as BoxProps,
    imgStyle: {
      width: 97,
      height: 32,
      overflow: 'hidden',
    },
    imageWrap: {
      pt: 3,
    } as BoxProps,
    topHeader: {
      pl: 25,
      pt: 40,
      flexDirection: 'row',
    } as BoxProps,
    prodIcons: {
      height: isScreenType ? (isMob || isTab ? 32 : 50) : 40,
      width: isScreenType ? (isMob || isTab ? 32 : 50) : 40,
    },
    iconStyle: {
      height: isScreenType ? (isMob || isTab ? 32 : 50) : 24,
      width: isScreenType ? (isMob || isTab ? 32 : 50) : 24,
    },
  }
}
